var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 36C30.6274 36 36 30.6274 36 24C36 17.3726 30.6274 12 24 12C17.3726 12 12 17.3726 12 24C12 30.6274 17.3726 36 24 36Z",
    fill: "url(#paint0_linear_3706_938)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.431 23.8734C20.9293 22.3493 23.262 21.3445 24.4292 20.8591C27.7617 19.4729 28.4542 19.2322 28.9055 19.2242C29.0048 19.2225 29.2267 19.2471 29.3705 19.3637C29.4919 19.4622 29.5253 19.5953 29.5413 19.6887C29.5573 19.7821 29.5772 19.9949 29.5614 20.1611C29.3808 22.0586 28.5994 26.6633 28.2018 28.7885C28.0336 29.6877 27.7024 29.9893 27.3817 30.0188C26.6849 30.0829 26.1557 29.5582 25.4808 29.1158C24.4246 28.4235 23.8279 27.9925 22.8028 27.3169C21.618 26.5362 22.386 26.1071 23.0612 25.4058C23.2379 25.2222 26.3083 22.4295 26.3677 22.1761C26.3752 22.1444 26.3821 22.0263 26.3119 21.964C26.2417 21.9016 26.1382 21.9229 26.0635 21.9399C25.9575 21.9639 24.2703 23.0791 21.0018 25.2855C20.5229 25.6143 20.0891 25.7746 19.7004 25.7662C19.272 25.7569 18.4478 25.5239 17.8351 25.3247C17.0836 25.0805 16.4863 24.9513 16.5383 24.5364C16.5654 24.3203 16.863 24.0993 17.431 23.8734Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3706_938",
    x1: 1212,
    y1: 12,
    x2: 1212,
    y2: 2394.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIc);
export default __webpack_public_path__ + "static/media/telegram_ic.52016342769e7b0faf33e7114cf6299b.svg";
export { ForwardRef as ReactComponent };